import { useContext } from "react";
import { boundingBoxO2, IObj2d } from "../../models/IObj";
import { hasDimensions } from "../../services/CabinetValidator";
import { TopPosConverter } from "../../util/PosConverter";
import { CommonEditorProps, EditorContext } from "../EditorCommon/EditorContext";


export function DoorImageTop() {
    const ec = useContext(EditorContext);


    if (!hasDimensions(ec.cabinet))
        throw new Error("dimensions not defined");

    const convert = new TopPosConverter();

    const doors = ec.cabinetService.getDoorInfos();
    const doorGroups = doors.map(door => (
        <g key={door.index} >
            <rect
                {...convert.size(door.size)}
                {...convert.pos(door.position, door.size)}
                className={`door-top door-top_${door.index}`}
            />
        </g>
    ));

    return (
        <g className="door-image-top">
            {doorGroups}
        </g>
    );
}


export module DoorImageTop {
    export function boundingBox(ec: CommonEditorProps): IObj2d {

        const doors = ec.cabinetService.getDoorInfos();
        const doorTopPoss = doors.map(door => ({
            position: { x: door.position.x, y: door.position.z },
            size: { x: door.size.x, y: door.size.z }
        }));
        return boundingBoxO2(...doorTopPoss);
    }
}
